<template lang="pug">
.v-hero-banner.hero-banner(v-if="banner" :class="{'hero-banner--has-image': banner.backgroundImage}" :style="{'background-collor': banner.backgroundColor}")
	img.hero-banner__background-image(v-if="banner.backgroundImage && !isSm" :src="banner.backgroundImage" alt="")
	img.hero-banner__background-image(v-else-if="(banner.backgroundImageMob || banner.backgroundImage) && isSm" :src="banner.backgroundImageMob || banner.backgroundImage" alt="")
	.hero-banner__container.container
		.hero-banner__wrap
			.hero-banner__content
				.hero-banner__content-left
					.hero-banner__action.flc(v-if="banner.button")
						button.hero-banner__link(type="button" @click="scrollToTarget")
							v-svg-icon.hero-banner__link-icon(icon="chevrons")
							.hero-banner__link-text {{banner.button.text}}
				.hero-banner__content-right
					.hero-banner__supertitle(v-if="banner.supertitle") {{banner.supertitle}}
					h1.hero-banner__title(v-if="banner.title" v-html="banner.title" )
					.hero-banner__text(v-if="banner.text") {{banner.text}}
					.main-banner__action.flc(v-if="banner.link")
						a.main-banner__link.btn.btn--has-right-icon.btn--primary(:href="banner.link.link" :class="{'btn--wide': isMd}")
							.btn__text {{banner.link.text}}
							.btn__icon-wrap
								v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
								v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import VSwiperSlider from "./v-swiper-slider.vue";
import {SwiperSlide} from "swiper/vue";

export default {
	components: {VSwiperSlider, SwiperSlide},
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			banner: null,
			options: {

			}
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		scrollToTarget() {
			window.scrollTo({
				top: window.innerHeight,
				behavior: 'smooth'
			});
		},

		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				document.body.classList.remove('state--page-header-blackout');
			}
		},

		dataSet(data) {
			this.banner = data;
			console.log(this.banner)
			this.handleScroll();
			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
